import { MorphemeMnemonicsPanelMeaningTabButton } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.tab-buttons.__components.meaning-tab-button";
import { MorphemeMnemonicsPanelTranscriptionTabButton } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.tab-buttons.__components.transcription-tab-button";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { useGetGraphemeGlyph } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.glyph/client";
import { useGraphemePanelsMnemonicsTabPress } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { View } from "@-/com.npmjs.react-native";
import type { MorphemeMnemonicsPanelTabButtonsGate } from "#use-morpheme-mnemonics-panel-tab-buttons-gate";

/** The mnemonics panel's primary navigation strip. Only `useMorphemeMnemonicsPanelTabButtonsGate` decides whether it shows. */
export function MorphemeMnemonicsPanelTabButtonsRenderer({
  activeIndex,
  gate,
}: {
  activeIndex: number;
  gate: MorphemeMnemonicsPanelTabButtonsGate;
}) {
  const { tabs } = gate;
  const [front] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.grapheme,
  );
  const getGraphemeGlyph = useGetGraphemeGlyph();
  const graphemeGlyph = getGraphemeGlyph(front);
  const getTabPressHandler = useGraphemePanelsMnemonicsTabPress();

  return (
    <View className="flex-row bg-surface">
      {tabs.map((tab, tabIndex) => {
        const focused = activeIndex === tabIndex;

        if (tab.name === "meaning") {
          return (
            <MorphemeMnemonicsPanelMeaningTabButton
              focused={focused}
              front={front}
              graphemeGlyph={graphemeGlyph}
              key={tab.name}
              onPress={getTabPressHandler(tabIndex)}
            />
          );
        }

        return (
          <MorphemeMnemonicsPanelTranscriptionTabButton
            focused={focused}
            key={tab.name}
            pinyin={tab.title}
            pinyinKey={tab.pinyin}
            tabIndex={tabIndex}
          />
        );
      })}
    </View>
  );
}
